<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-8 offset-2 col-md-4 offset-md-4 text-center">
        <h4>Vali projekt</h4>
        <div class="list-group">
          <span v-for="(project, index) in $store.state.projects" :key="index" @click="setProject(project.name)" class="cursor-pointer list-group-item list-group-item-action">{{ project.description }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    '$store.state.projects': function () {
      // Auto select project if only one is available
      if (this.$store.state.projects.length === 1) {
        this.setProject(this.$store.state.projects[0].name)
      }
    }
  },
  mounted () {
    // Reset project selection
    this.$store.commit('setProject', null)
    this.$store.commit('setStations', [])
  },
  sockets: {
    /*
    projectConfig: function (data) {
      // console.log('projectConfig', data)
      this.$store.commit('setProject', data.general)
      this.$store.commit('setStations', data.stations)
      this.$router.push('/view/station/' + this.$store.state.stations[0].id)
    }
     */
  },
  methods: {
    // Set project as selected by user or as auto selected
    setProject (project) {
      console.log('setting project to', project)
      this.$socket.emit('setProject', project)
    }
  }
}
</script>
